"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusTable = void 0;
const i18next_1 = require("i18next");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const common_1 = require("../../../../common");
const option_1 = require("../../../../common/option");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const StatusTableStyled = styled_components_1.default.div `
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 8px;

	.student-table-wrap {
		width: 100%;
	}

	.student-table-wrap .report-list-001 .table-header .table-header-item {
		justify-content: center;
		text-align: center;
	}

	.student-table-wrap .report-list-001 .table-header .head-class_name,
	.student-table-wrap .report-list-001 .table-header .head-testName,
	.student-table-wrap .report-list-001 .table-header .head-title {
		justify-content: flex-start;
		text-align: left;
	}

	.student-table-wrap .report-list-001 .table-header .head-class_name p,
	.student-table-wrap .report-list-001 .table-header .head-testName p,
	.student-table-wrap .report-list-001 .table-header .head-title p {
		text-align: left;
	}

	.student-score-guide {
		text-align: right;
		color: var(--color-grey-w, #b6bac0);
		font-family: 'Noto Sans KR', sans-serif;
		font-size: ${props => (props.$isMobile ? '12px' : '16px')};
		line-height: 150%;
		letter-spacing: -0.02em;
		margin-bottom: 8px;
	}

	.student-status,
	.student-score,
	.student-duration {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.badge {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		padding: 2px 10px;
		border-radius: 6px;
		font-size: ${props => (props.$isMobile ? '12px' : '14px')};
		line-height: 1.3;
		font-weight: 400;
		white-space: nowrap;
		border: 1px solid #d7d9dc;
		background: #fff;
		color: #101010;
	}

	.badge.attend,
	.badge.submit {
		background: #fff;
		border-color: #d7d9dc;
		color: #101010;
	}

	.badge.late {
		background: #f3f1c9;
		border-color: #e2de95;
		color: #101010;
	}

	.badge.absent,
	.badge.not-submit {
		background: #dbdde0;
		border-color: #d1d4d8;
		color: #101010;
	}

	.clickable-score {
		text-decoration: underline;
		text-underline-offset: 2px;
		cursor: pointer;
	}

	.clickable-score:hover {
		opacity: 0.85;
	}

	.student-card-list {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	/* p.30: 큰 3요소 카드 → 세로 폭이 축소된 슬림 리스트 행.
	   그리드 1행 구성 [상태칩 | 제목(1줄)·메타(2줄) | 성적표버튼], 카드 테두리 대신 구분선. */
	.student-card {
		width: 100%;
		display: grid;
		grid-template-columns: auto minmax(0, 1fr) auto;
		grid-template-rows: auto auto;
		column-gap: 10px;
		row-gap: 2px;
		align-items: center;
		padding: ${props => (props.$isMobile ? '10px 2px' : '12px 4px')};
		border-bottom: 1px solid #eef0f3;
		background: #fff;
	}

	.student-card-header {
		grid-column: 1;
		grid-row: 1 / span 2;
		display: flex;
		align-items: center;
		align-self: center;
	}

	.student-status-chip-wrap {
		display: inline-flex;
		justify-content: flex-start;
		flex-shrink: 0;
	}

	.student-status-chip {
		min-width: 44px;
		text-align: center;
		border: 1px solid var(--color-grey-w, #b6bac0);
		border-radius: 6px;
		padding: 2px 8px;
		color: var(--color-black, #101010);
		font-size: 12px;
		font-weight: 700;
		line-height: 150%;
		white-space: nowrap;
		background: #fff;
	}

	.student-status-chip.late {
		background: #f3f1c9;
		border-color: #e2de95;
	}

	.student-status-chip.absent,
	.student-status-chip.not-submit {
		background: var(--color-silver, #f3f4f8);
	}

	.student-card-title {
		grid-column: 2;
		grid-row: 1;
		min-width: 0;
		color: var(--color-black, #101010);
		font-family: 'Noto Sans KR', sans-serif;
		font-size: ${props => (props.$isMobile ? '14px' : '15px')};
		line-height: 1.4;
		letter-spacing: -0.02em;
		font-weight: 700;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.student-card-meta {
		grid-column: 2;
		grid-row: 2;
		color: var(--color-grey-l, #83868a);
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 12px;
		line-height: 1.45;
		letter-spacing: -0.02em;
	}

	.student-score-cta {
		grid-column: 3;
		grid-row: 1 / span 2;
		align-self: center;
		width: auto;
		border: none;
		border-radius: 8px;
		background: #101010;
		color: #fff;
		text-align: center;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 13px;
		line-height: 1.3;
		font-weight: 600;
		padding: 7px 12px;
		cursor: pointer;
		white-space: nowrap;
	}

	.report-list-001 {
		display: flex;
		flex-direction: column;
		align-self: stretch;

		.table-header {
			background: var(--color-silver, #f3f4f8);
			border-style: solid;
			border-color: var(--color-grey-w, #b6bac0);
			border-width: 1px 0 0 0;
			padding: 10px 16px;
			display: flex;
			gap: 20px;
			align-items: center;

			p {
				color: var(--color-black, #101010);
				text-align: left;
				font-family: 'Noto Sans KR', sans-serif;
				${props => props.$isDesktop
    ? `font-size: var(--b3-font-size, 16px); line-height: var(--b3-line-height, 32px); letter-spacing: var(--b3-letter-spacing, -0.02em);`
    : props.$isMobile
        ? `font-size: 12px; line-height: 150%; letter-spacing: -0.02em;`
        : `font-size: 14px; line-height: 150%; letter-spacing: -0.02em;`};
				flex: 1;
			}
		}

		.item {
			padding: 10px 16px;
			display: flex;
			gap: 20px;
			align-items: center;

			span {
				color: var(--color-black, #101010);
				text-align: left;
				font-family: 'Noto Sans KR', sans-serif;
				${props => props.$isDesktop
    ? `font-size: var(--b3-font-size, 16px); line-height: var(--b3-line-height, 32px); letter-spacing: var(--b3-letter-spacing, -0.02em);`
    : props.$isMobile
        ? `font-size: 12px; line-height: 150%; letter-spacing: -0.02em;`
        : `font-size: 14px; line-height: 150%; letter-spacing: -0.02em;`};
				font-weight: 400;
			}
		}
	}
`;
const getAttendanceState = (item) => {
    if (item?.status === 'late' || item?.attendance_status === 'late' || item?.late === true) {
        return { text: '지각', className: 'late' };
    }
    if (item?.done)
        return { text: '출석', className: 'attend' };
    return { text: '결석', className: 'absent' };
};
const getStudentName = (item, studentType) => {
    if (studentType === 'attend')
        return item?.conference_name || '-';
    return item?.test_name || item?.conference_name || item?.title || '-';
};
const getDurationText = (item) => {
    // 지각(late)은 done=false 지만 실제 참여시간이 존재한다 — 출석(done)과 동일하게 표시.
    // (교사 리포트 DSTL006 은 done 게이트 없이 표시 중 — 학생 리포트만 누락돼 있던 것 수정)
    const isLate = item?.status === 'late' || item?.attendance_status === 'late' || item?.late === true;
    if (!item?.done && !isLate)
        return '-';
    const attendMinutes = Number(item?.attend_time);
    if (Number.isFinite(attendMinutes) && attendMinutes >= 0) {
        return `${Math.floor(attendMinutes)}분`;
    }
    return '-';
};
const getScoreText = (item) => {
    if (!item?.done || item?.score === -1 || item?.score === undefined || item?.score === null) {
        return '-';
    }
    return String(item.score);
};
const getStudentDateText = (item) => item?.startline ? (0, moment_1.default)(item.startline).format('YYYY-MM-DD') : '-';
exports.StatusTable = react_1.default.memo(({ testData = [], totalCount, studentType, showGuide = false, onScoreClick, disableScoreLink = false, }) => {
    const { isDesktop, isMobile, isTablet } = (0, GlobalStateProvider_1.useGlobalState)();
    if (!studentType) {
        return null;
    }
    const dateCol = { space: 0.85 };
    const nameCol = { space: 3.55 };
    const statusSubmitCol = { space: 1 };
    const durationScoreCol = { space: 0.8 };
    const headTitleList = studentType === 'attend'
        ? [
            { title: 'attendDate', ...dateCol },
            { title: 'class_name', ...nameCol },
            { title: 'attendanceStatus', ...statusSubmitCol },
            { title: 'participantTime', ...durationScoreCol },
        ]
        : [
            { title: 'examinationDate', ...dateCol },
            { title: studentType === 'test' ? 'testName' : 'title', ...nameCol },
            { title: 'examStatus', ...statusSubmitCol },
            { title: 'grades', ...durationScoreCol },
        ];
    const tableReadDataKeys = studentType === 'attend'
        ? [
            { title: 'date', ...dateCol },
            { title: 'name', ...nameCol },
            { title: 'status', ...statusSubmitCol },
            { title: 'duration', ...durationScoreCol },
        ]
        : [
            { title: 'date', ...dateCol },
            { title: 'name', ...nameCol },
            { title: 'submit', ...statusSubmitCol },
            { title: 'score', ...durationScoreCol },
        ];
    const getStudentMetaText = (item) => {
        const dateText = getStudentDateText(item);
        if (studentType === 'attend') {
            const durationText = getDurationText(item);
            return durationText === '-' ? dateText : `${dateText} · 참여 ${durationText}`;
        }
        const scoreText = getScoreText(item);
        return scoreText === '-' ? dateText : `${dateText} · 점수 ${scoreText}점`;
    };
    const canOpenScoreDetail = (item) => studentType !== 'attend' &&
        !disableScoreLink &&
        typeof onScoreClick === 'function' &&
        getScoreText(item) !== '-';
    const renderEmpty = testData.length === 0 ? react_1.default.createElement(option_1.EmptyTable, { title: (0, i18next_1.t)('assignment.noSubmitInfo') }) : undefined;
    if (!isDesktop) {
        return (react_1.default.createElement(StatusTableStyled, { "$isDesktop": isDesktop, "$isMobile": isMobile, "$isTablet": isTablet },
            showGuide && react_1.default.createElement("div", { className: "student-score-guide" }, "* \uC810\uC218 \uD074\uB9AD \uC2DC \uC0C1\uC138 \uD654\uBA74\uC73C\uB85C \uC774\uB3D9\uD569\uB2C8\uB2E4"),
            react_1.default.createElement("div", { className: "student-card-list" },
                testData.map((item, index) => {
                    const attendanceState = studentType === 'attend' ? getAttendanceState(item) : undefined;
                    const statusClassName = studentType === 'attend'
                        ? attendanceState?.className || 'attend'
                        : item?.done
                            ? 'submit'
                            : 'not-submit';
                    const statusText = studentType === 'attend'
                        ? attendanceState?.text || '-'
                        : item?.done
                            ? '응시'
                            : '미응시';
                    const canOpenScore = canOpenScoreDetail(item);
                    return (react_1.default.createElement("div", { key: `${item?.test_id || item?.id || 'student-row'}-${index}`, className: "student-card" },
                        react_1.default.createElement("div", { className: "student-card-header" },
                            react_1.default.createElement("div", { className: "student-status-chip-wrap" },
                                react_1.default.createElement("span", { className: `student-status-chip ${statusClassName}` }, statusText))),
                        react_1.default.createElement("div", { className: "student-card-title" }, getStudentName(item, studentType)),
                        react_1.default.createElement("div", { className: "student-card-meta" }, getStudentMetaText(item)),
                        canOpenScore && (react_1.default.createElement("button", { type: "button", className: "student-score-cta", onClick: () => onScoreClick(item, studentType) }, "\uC131\uC801\uD45C \uBCF4\uAE30"))));
                }),
                renderEmpty)));
    }
    const renderItem = (item, styles) => tableReadDataKeys.map((headItem, index) => {
        const commonStyle = {
            flex: headItem.space,
            maxWidth: headItem.maxWidth,
            ...styles?.bodyItem,
            overflow: 'hidden',
        };
        switch (headItem.title) {
            case 'date':
                return (react_1.default.createElement("div", { key: headItem.title + index, style: { ...commonStyle, display: 'flex', justifyContent: 'center' } },
                    react_1.default.createElement("span", null, getStudentDateText(item))));
            case 'name':
                return (react_1.default.createElement("div", { key: headItem.title + index, style: { ...commonStyle, display: 'flex', justifyContent: 'flex-start' } },
                    react_1.default.createElement("span", { className: "overText2" }, getStudentName(item, studentType))));
            case 'status': {
                const status = getAttendanceState(item);
                return (react_1.default.createElement("div", { key: headItem.title + index, className: "student-status", style: commonStyle },
                    react_1.default.createElement("span", { className: `badge ${status.className}` }, status.text)));
            }
            case 'duration':
                return (react_1.default.createElement("div", { key: headItem.title + index, className: "student-duration", style: commonStyle },
                    react_1.default.createElement("span", null, getDurationText(item))));
            case 'submit':
                return (react_1.default.createElement("div", { key: headItem.title + index, className: "student-status", style: commonStyle },
                    react_1.default.createElement("span", { className: `badge ${item?.done ? 'submit' : 'not-submit'}` }, item?.done ? '응시' : '미응시')));
            case 'score': {
                const scoreText = getScoreText(item);
                const canClickScore = scoreText !== '-' && !disableScoreLink && typeof onScoreClick === 'function';
                return (react_1.default.createElement("div", { key: headItem.title + index, className: "student-score", style: commonStyle },
                    react_1.default.createElement("span", { className: canClickScore ? 'clickable-score' : undefined, role: canClickScore ? 'button' : undefined, tabIndex: canClickScore ? 0 : undefined, onClick: canClickScore ? () => onScoreClick(item, studentType) : undefined, onKeyDown: canClickScore
                            ? e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    onScoreClick(item, studentType);
                                }
                            }
                            : undefined }, scoreText)));
            }
            default:
                return (react_1.default.createElement("div", { key: headItem.title + index, style: commonStyle },
                    react_1.default.createElement("span", null, "-")));
        }
    });
    return (react_1.default.createElement(StatusTableStyled, { "$isDesktop": isDesktop, "$isMobile": isMobile, "$isTablet": isTablet },
        showGuide && react_1.default.createElement("div", { className: "student-score-guide" }, "* \uC810\uC218 \uD074\uB9AD \uC2DC \uC0C1\uC138 \uD654\uBA74\uC73C\uB85C \uC774\uB3D9\uD569\uB2C8\uB2E4"),
        react_1.default.createElement("div", { className: "student-table-wrap" },
            react_1.default.createElement(common_1.Table, { className: "report-list-001", headTitleList: headTitleList, isInfinite: true, data: testData, page: 0, totalCount: totalCount, renderEmpty: renderEmpty, renderItem: renderItem, forceShowheader: true, padding: false }))));
});
exports.default = exports.StatusTable;
